// extracted by mini-css-extract-plugin
export default {"container":"TitleModules_container__Tqcv7","icon":"TitleModules_icon__svAhF","title":"TitleModules_title__SpcB5"};